package com.yogaaicoach.common.network

import Config
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.Serializable

@Serializable
private data class LogKeyEventRequest(val event: String)

class KeyEventApi(private val apiClient: ApiClient) {
    suspend fun logKeyEvent(event: String) {
        try {
            apiClient.publicClient.post("${Config.API_URL}/public/log-key-event") {
                contentType(ContentType.Application.Json)
                setBody(LogKeyEventRequest(event))
            }
        } catch (_: Exception) {
            // fire-and-forget: ignore all failures silently
        }
    }
}
